import { useState, useEffect } from "react";
import { accountAPI, reminderAPI, transactionAPI } from "services";
import { ExpandableButton, Loader } from "components";
import ReminderAlert from "alerts/ReminderAlert";
import { NewTxn, EditTxn, EditRTxn } from "forms";
import useUniversalStore from "store/universalStore";
import Header from "./Header";
import Footer from "./Footer";
import TxnsListView from "./TxnsListView";
import RecursivetxnsView from "forms/Recursive/RecursivetxnsView";

const Khata = () => {
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [reminder, setReminder] = useState(null);
  const [hideCancelled, setHideCancelled] = useState(false);
  const { accountId, isReminderChanged, write, accounts } = useUniversalStore((state) => state);
  const [month, setMonth] = useState(new Date());
  const account = accounts.find((acc) => acc.id === accountId);
  
  //TODO : needs to be moved to relevant component
  const [animation, setAnimation] = useState("");

  //const goToNextStep = useOnboardingStore((state) => state.goToNextStep);

  //intially fetch the transctions and if payment overdue then show overLayer blur effect
  useEffect(() => {
    if (accountId && month) {
      fetchTransactions();
    }
    //fetchReminder();
  }, [accountId, month, isReminderChanged]);

  const fetchTransactions = async () => {
    try {
      const results = await transactionAPI.getTransactionsByAccountIdWithMonth(accountId,month);
      write({ transactions: results });
    } catch (error) {
      console.error(error);
    }
  };

  //method to fetch Remainder and add results in global store
  const fetchReminder = async () => {
    try {
      const response = await reminderAPI.fetchReminder(accountId);
      if(response){
        setReminder(response[0])
        checkOverdueReminder(response[0]);
      }
    } catch (error) {
      console.log("fetchRemainder error ", error);
    }
  };

  //method to check the overdue reminder
  const checkOverdueReminder = (reminder) => {
    if (reminder) {
      const remainderSheduleTime = reminder?.get("date");
      const reminderEnable = reminder?.get("enabled");
      const paymentOverdue = remainderSheduleTime?.getTime() < Date.now();
      setOverlayVisible(paymentOverdue && reminderEnable);
    } else {
      setOverlayVisible(false);
    }
  };

  const editTxn = (data) => write({ transactionId: data.id });

  /*  const confirmit = (txn) => {
    write((prev) => {
      let tempVar = { ...prev.deleteTransactions };
      tempVar.type = "Transaction";
      tempVar.object = txn;
      return { ...prev, deleteTransactions: tempVar };
    });
    const toDel = { delTxn: txn };
    
    // setDeletionOf(txn);
  };*/

  const handleNewDate = (newDate) => {
    setMonth(newDate);
  };

  const handleToggle = (value)=>{
    setHideCancelled(value);
  }

  const closeReminderAlert = async ()=>{
    //setOverlayVisible(false);
    await reminderAPI.toggleReminder(reminder?.id);
    //setShowReminder(false);
    setOverlayVisible(false);
    write({ isReminderChanged:true })
  }

  if (!account) return <Loader />;

  return (
    <>
      <div className="position-relative">
        {/* Overlay for background blur and disabling interaction */}
        {isOverlayVisible && (
          <div className="overlay d-flex justify-content-center align-items-center">
            <ReminderAlert
              account={account}
              closeReminderAlert={closeReminderAlert}  />
          </div>
        )}
        <div className={`content-container ${isOverlayVisible ? "disabled" : ""}`}>
          <Header
            month={month}
            handleNewDate={handleNewDate}
            account={account}
            setAnimation={setAnimation}
            hideCancelled={hideCancelled}
            handleToggle={handleToggle}
          />

          <TxnsListView
            hideCancelled={hideCancelled}
            monthlyDate={month}
            editTxn={editTxn}
            animation={animation}
            setAnimation={setAnimation}
          />
          {/* Only shows button when a valid user exists */}
          <div
            style={{ paddingBottom: 125, paddingRight: 50 }}
            className="position-fixed bottom-0 end-0"
          >
            <ExpandableButton
              title="New Entry"
              formId="newTxn"
              icon="bi bi-pencil-fill"
            />
          </div>

          
          <Footer account={account} />

          <RecursivetxnsView account={account} />
          <EditRTxn />
        </div>
      </div>
    </>
  );
};

export default Khata;